import { EXTRA_ROUTES, NAV } from './nav'

/** One user-facing feature: a nav item (or an extra route) of the staff web. */
export interface Feature {
  id: string
  to: string
  section: string
}

/**
 * The feature list the rollout plan must cover. Snapshot in features.json, which the Go test
 * internal/rollout/catalog_test.go reads: every feature needs at least one rollout stage.
 */
export function featureList(): Feature[] {
  const out: Feature[] = []
  const seen = new Set<string>()
  const add = (id: string, to: string, section: string) => {
    if (seen.has(id)) return
    seen.add(id)
    out.push({ id, to, section })
  }
  for (const s of NAV) for (const i of s.items) add(i.id, i.to, s.id)
  for (const i of EXTRA_ROUTES) add(i.id, i.to, 'extra')
  return out
}

/** Nav feature id of a pathname (longest matching route wins), for page-visit tracking. */
export function featureOf(pathname: string): string | undefined {
  let best: Feature | undefined
  for (const f of featureList()) {
    const hit = f.to === '/' ? pathname === '/' : pathname === f.to || pathname.startsWith(f.to + '/')
    if (hit && (!best || f.to.length > best.to.length)) best = f
  }
  return best?.id
}
